import React, { Fragment } from "react";

import { Dialog, Transition } from "@headlessui/react";

import { classNames } from "../../../../utils/classNames";

import { ModalSize } from "./Modal.types";
import { MODAL_HOLDER_SIZE_CLASSNAMES, MODAL_SIZE_CLASSNAMES } from "./Modal.utils";

type ModalProps = {
    isOpen: boolean;
    onClose: () => void;
    size?: ModalSize;
    disableAutofocus?: boolean;
};

export const Modal: React.FC<React.PropsWithChildren<ModalProps>> = ({
    isOpen,
    onClose,
    size,
    children,
    disableAutofocus,
}) => {
    return (
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-neutral-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div
                        className={`flex min-h-full items-start justify-center p-4 text-center sm:items-center ${
                            MODAL_HOLDER_SIZE_CLASSNAMES[size ?? ModalSize.Small]
                        }`}
                    >
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className={classNames(
                                    "relative transform rounded-lg bg-white p-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:p-6",
                                    MODAL_SIZE_CLASSNAMES[size ?? ModalSize.Small],
                                )}
                            >
                                {disableAutofocus && <div tabIndex={1} aria-hidden="true"></div>}
                                {children}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
};
